"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.anyValuesChanged = exports.getRefs = exports.getPathPrefixFromPath = exports.formattedPath = exports.getTruePath = void 0;
const lodash_1 = __importDefault(require("lodash"));
const getTruePath = (sourcePath, controlPath) => {
    let cleanSource = sourcePath;
    // when a conditional depend on a field in the same group
    // the sourComponent will start with '~.'
    // example '~.abc' and controlPath 'xyzGroup.xyzField, expected result => xyzGroup.abc (sibling field)
    // else it is not part of the group but a parent or root and the sourcePath should be the correct one
    if (sourcePath.startsWith('~.')) {
        cleanSource = sourcePath.replace('~.', '');
        return (0, exports.formattedPath)(cleanSource, (0, exports.getPathPrefixFromPath)(controlPath));
    }
    return sourcePath;
};
exports.getTruePath = getTruePath;
const formattedPath = (sourcePath, pathPrefix) => {
    return pathPrefix ? `${pathPrefix}.${sourcePath}` : sourcePath;
};
exports.formattedPath = formattedPath;
const getPathPrefixFromPath = (controlPath) => {
    if (!controlPath)
        return '';
    const indexStart = controlPath.lastIndexOf('.');
    return controlPath.substring(0, indexStart);
};
exports.getPathPrefixFromPath = getPathPrefixFromPath;
const getRefs = (map, nodes) => {
    const ret = {};
    if (map.nodes) {
        Object.keys(map.nodes).forEach((key) => {
            if (map.nodes) {
                const inputs = map.nodes[key].inputs || {};
                Object.keys(inputs).forEach((k) => {
                    if (inputs[k]) {
                        let items = [];
                        if (!Array.isArray(inputs[k])) {
                            items = [inputs[k]];
                        }
                        else {
                            items = inputs[k];
                        }
                        for (const node of items) {
                            if (node['sourceObject'] && map.nodes && nodes.includes(map.nodes[node['sourceObject']].type || '')) {
                                if (ret[map.nodes[node['sourceObject']].type || ''] &&
                                    !ret[map.nodes[node['sourceObject']].type || ''].includes(node['sourcePath'])) {
                                    ret[map.nodes[node['sourceObject']].type || ''].push(node['sourcePath'].replace(/^\$\./, ''));
                                }
                                else if (!ret[map.nodes[node['sourceObject']].type || '']) {
                                    ret[map.nodes[node['sourceObject']].type || ''] = [node['sourcePath'].replace(/^\$\./, '')];
                                }
                            }
                        }
                    }
                });
            }
        });
    }
    return ret;
};
exports.getRefs = getRefs;
const anyValuesChanged = (refs, previous, current) => {
    return (refs &&
        lodash_1.default.some(refs, (val) => {
            return !lodash_1.default.isEqual(lodash_1.default.get(previous, val), lodash_1.default.get(current, val));
        }));
};
exports.anyValuesChanged = anyValuesChanged;
